import { Component, Input, OnInit } from '@angular/core';
import { LinkedCard } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgbcl-card-linked-list',
  templateUrl: './card-linked-list.component.html',
  styleUrls: ['./card-linked-list.component.scss']
})
export class CardLinkedListComponent implements OnInit {
  @Input() linkedCardList: LinkedCard[];
  
  customOptions: OwlOptions = {
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      540: { items: 3 },
      740: { items: 5 },
    },
  };
  screenType = ScreenType;
  
  constructor() {}

  ngOnInit(): void {
  }
}
